/**
 * Exam-complete chapter notes.
 *   Batch 1: CBSE Plus One Accountancy (cbse-11-acc-*)
 *   Batch 2: Kerala Plus One Accountancy with AFS (ker-11-acc-*)
 *
 * Original, independently fact-checked revision notes (each file has
 * verified=true after the fact-check gate). Rendered in the chapter "Notes"
 * tab and (next) exported as PDF/Word. To add a chapter, drop a
 * <chapterId>.json here matching the schema and import it below.
 */
export interface NoteKeyTerm { term: string; definition: string; }
export interface NoteConcept { heading: string; points: string[]; }
export interface NoteQuestion { q: string; marks: number; answer: string[]; }
export interface ChapterNotes {
  chapterId: string;
  title: string;
  board: string;
  grade: string;
  subject: string;
  overview: string;
  keyTerms: NoteKeyTerm[];
  concepts: NoteConcept[];
  formulasFormats: string[];
  importantQuestions: NoteQuestion[];
  examTips: string[];
  revision: string[];
  verified: boolean;
  verifierNotes?: string;
}

import bills from './cbse-11-acc-bills.json';
import brs from './cbse-11-acc-brs.json';
import comp from './cbse-11-acc-comp.json';
import depr from './cbse-11-acc-depr.json';
import fsSole1 from './cbse-11-acc-fs-sole-1.json';
import fsSole2 from './cbse-11-acc-fs-sole-2.json';
import incomplete from './cbse-11-acc-incomplete.json';
import intro from './cbse-11-acc-intro.json';
import recording1 from './cbse-11-acc-recording-1.json';
import recording2 from './cbse-11-acc-recording-2.json';
import tb from './cbse-11-acc-tb.json';
import theory from './cbse-11-acc-theory.json';

// Kerala Plus One Accountancy (with AFS) — Batch 2
import kerBills from './ker-11-acc-bills.json';
import kerBrs from './ker-11-acc-brs.json';
import kerComp from './ker-11-acc-comp.json';
import kerDepr from './ker-11-acc-depr.json';
import kerFinal from './ker-11-acc-final.json';
import kerIncomplete from './ker-11-acc-incomplete.json';
import kerIntro from './ker-11-acc-intro.json';
import kerRecord1 from './ker-11-acc-record-1.json';
import kerRecord2 from './ker-11-acc-record-2.json';
import kerTb from './ker-11-acc-tb.json';
import kerTheory from './ker-11-acc-theory.json';

export const allChapterNotes = [
  // CBSE Plus One Accountancy — Batch 1
  bills, brs, comp, depr, fsSole1, fsSole2,
  incomplete, intro, recording1, recording2, tb, theory,
  // Kerala Plus One Accountancy (with AFS) — Batch 2
  kerBills, kerBrs, kerComp, kerDepr, kerFinal, kerIncomplete, kerIntro, kerRecord1, kerRecord2, kerTb, kerTheory,
] as unknown as ChapterNotes[];

const byId: Record<string, ChapterNotes> = {};
for (const n of allChapterNotes) byId[n.chapterId] = n;

export const getChapterNotes = (chapterId: string): ChapterNotes | undefined => byId[chapterId];
export const hasChapterNotes = (chapterId: string): boolean => chapterId in byId;
